import { useState } from 'react';
import { BASE_URL } from '../../../utils/Constants';

interface StripeItemData {
  data: {
    sku: string | null;
    price: number;
    currency: string;
    discount: number;
    duration: string;
    interval: string;
    order_id: string;
    quantity: number;
    item_type: string;
    created_at: string;
    is_renewal: boolean;
    product_id: string;
    updated_at: string;
    variant_id: string;
    contract_id: string;
    customer_id: string;
    product_name: string;
    contract_note: string | null;
    customer_mail: string;
    interval_count: number;
    contract_status: string;
    shipping_address: {
      zip: string;
      city: string;
      phone: string;
      company: string | null;
      country: string;
      address1: string;
      address2: string | null;
      province: string;
      last_name: string;
      time_zone: string;
      first_name: string;
      country_code: string;
      province_code: string;
    };
  };
}

interface UseCreateStripeItemReturn {
  createStripeItem: (data: StripeItemData) => Promise<void>;
  isLoading: boolean;
  error: string | null;
  success: boolean;
}

export const useCreateStripeItem = (): UseCreateStripeItemReturn => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const createStripeItem = async (data: StripeItemData): Promise<void> => {
    setIsLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await fetch(`${BASE_URL}/api/sorting`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log('Stripe item created successfully:', result);
      setSuccess(true);
      
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'An unknown error occurred';
      console.error('Error creating stripe item:', errorMessage);
      setError(errorMessage);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    createStripeItem,
    isLoading,
    error,
    success,
  };
};
